import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import {UserGetSchema} from '../../../../api/DBSchema/User';
import SMCTextInput from '../../../../components/Simple/SMCTextInput';
import SMCTextArea from '../../../../components/Simple/SMCTextArea';

const pageSchema = UserGetSchema.pages.contact;
const pageId = pageSchema.pageId;

function UserContact({
    userObject,
    setUserData
}) {
    const { t } = useTranslation();

    const pageData = userObject[pageId];
    const setPageValue = useCallback((paramName, value) => {
        setUserData([pageId, paramName], value);
    }, [setUserData]);

    const phone   = pageData[pageSchema.phone];
    const mobile  = pageData[pageSchema.mobile];
    const fax     = pageData[pageSchema.fax];
    const address = pageData[pageSchema.address];
    const country = pageData[pageSchema.country];
    const state   = pageData[pageSchema.state];
    const zip     = pageData[pageSchema.zip];

    return (
        <EditorLayout>
            <SMCTextInput
                value={phone}
                onChange={e => setPageValue(pageSchema.phone, e.target.value)}
                label={t('SMP.USERS.TABLE.PAGES.CONTACT.PHONE')}
            />
            <SMCTextInput
                value={mobile}
                onChange={e => setPageValue(pageSchema.mobile, e.target.value)}
                label={t('SMP.USERS.TABLE.PAGES.CONTACT.MOBILE')}
            />
            <SMCTextInput
                value={fax}
                onChange={e => setPageValue(pageSchema.fax, e.target.value)}
                label={t('SMP.USERS.TABLE.PAGES.CONTACT.FAX')}
            />
            <SMCTextArea
                value={address}
                onChange={e => setPageValue(pageSchema.address, e.target.value)}
                label={t('SMP.USERS.TABLE.PAGES.CONTACT.MAILING_ADDRESS')}
            />
            <SMCTextInput
                value={country}
                onChange={e => setPageValue(pageSchema.country, e.target.value)}
                label={t('SMP.USERS.TABLE.PAGES.CONTACT.COUNTRY')}
            />
            <SMCTextInput
                value={state}
                onChange={e => setPageValue(pageSchema.state, e.target.value)}
                label={t('SMP.USERS.TABLE.PAGES.CONTACT.STATE')}
            />
            <SMCTextInput
                value={zip}
                onChange={e => setPageValue(pageSchema.zip, e.target.value)}
                label={t('SMP.USERS.TABLE.PAGES.CONTACT.ZIP_CODE')}
            />
        </EditorLayout>
    )
}

export default UserContact;